import useMutationApi from 'src/api/useMutationApi';
import {
  SalesOrderStatus,
  SalesOrderSyncStatus,
} from 'src/types/application/SalesOrderDTOV2_DEPRECATED';
import type { ApprovalIssue } from 'src/types/application/SalesOrderDraftDTO';

/** Per-line-item issue payload sent to the approve endpoint. */
export interface ApproveIssuePayload {
  /** Index of the line item in the draft's lineItems array */
  lineItemIndex: number;
  issue: ApprovalIssue;
}

/** Body sent when approving a sales order draft. */
export interface ApproveSalesOrderDraftBody {
  issues?: ApproveIssuePayload[];
}

const useApproveSalesOrderDraft = (
  salesOrderDraftId: string,
  onSuccess?: (params: {
    salesOrderId: string;
    status: SalesOrderStatus;
    originSyncStatus: SalesOrderSyncStatus | null;
  }) => void,
  onError?: (error: Error) => void,
) => {
  return useMutationApi<
    ApproveSalesOrderDraftBody,
    {
      salesOrderId: string;
      status: SalesOrderStatus;
      originSyncStatus: SalesOrderSyncStatus | null;
    }
  >({
    endpoint: `accounts-receivable/staged-purchase-orders/${salesOrderDraftId}/approve`,
    method: 'POST',
    successMessage: 'Sales order draft approved successfully',
    options: {
      onSuccess: onSuccess
        ? (data) => {
            onSuccess(data.data);
          }
        : undefined,
      onError: onError
        ? (error) => {
            onError(error as Error);
          }
        : undefined,
    },
  });
};

export default useApproveSalesOrderDraft;
